<div class="header">
    <h3>{{ 'brand.businessInfo.title' | translate}}</h3>
</div>

<txp-loading data-qa-label="Loader" [color]="loadingColor.COLOR" *ngIf="dataLoading()"></txp-loading>

<div class="messages">
    <txp-message [type]="messageType.DANGER"
                 data-qa-label="LoadDataError"
                 *ngIf="showDataLoadError">
        {{ 'brand.businessInfo.loadDataErrorMsg' | translate }}
    </txp-message>
    <txp-message [type]="messageType.DANGER"
                 data-qa-label="FormError"
                 *ngIf="showError">
        {{ 'brand.businessInfo.saveFailMsg' | translate }}
    </txp-message>
</div>

<form class="form-container" [formGroup]="form" *ngIf="!dataLoading()" [ngClass]="{ 'create': isCreate }">
    <div class="form-content">
        <mat-form-field class="brand-name">
            <mat-label>{{'brand.businessInfo.brandName' | translate }}</mat-label>
            <input #name matInput
                    data-qa-label="BrandNameInput"
                    required
                    formControlName="name">
            <span matSuffix class="lbl" (click)="name.value = ''"></span>
            <mat-error>
                {{ 'form.error.required' | translate }}
            </mat-error>
        </mat-form-field>

        <mat-form-field class="email" *ngIf="createSandBox">
            <mat-label>{{ 'brand.businessInfo.tenantEmail' | translate }}</mat-label>
            <input formControlName="email"
                   data-qa-label="TenantEmail"
                   type="email"
                   matInput />
            <mat-error *ngIf="form.get('email')?.errors?.pattern">
                {{ 'form.error.enterValidEmail' | translate }}
            </mat-error>
        </mat-form-field>

        <mat-form-field class="countries">
            <input #countryFilterInput
                   matInput
                   type="text"
                   [value]="countryFilterInput.value"
                   *ngIf="countrySelect.panelOpen"
                   [placeholder]="inputFocused ? ('brand.businessInfo.country' | translate) : null"
                   (input)="filteredCountries = filterItems(countryFilterInput.value, countries, 'countryName')"
                   (focus)="inputFocused = true"
                   (blur)="inputFocused = false">
            <!-- Hide mat-select when input is focused -->
            <mat-select matInput
                        #countrySelect
                        data-qa-label="CountryInput"
                        panelClass="custom-autocomplete-select country-select"
                        [ngClass]="{ 'hidden-select': countrySelect.panelOpen }"
                        disableOptionCentering
                        class="country-select"
                        formControlName="countryCode"
                        placeholder="{{ 'brand.businessInfo.country' | translate }}"
                        (selectionChange)="onSelectCountry($event)">
                <mat-option *ngFor="let country of filteredCountries"
                            [value]="country.countryCode"
                            class="option">
                    {{ country.countryName }}
                </mat-option>
            </mat-select>
            <mat-error>
                {{ 'form.error.required' | translate }}
            </mat-error>
        </mat-form-field>

        <mat-form-field class="alias">
            <mat-label>{{ 'brand.businessInfo.alias' | translate }}</mat-label>
            <input #alias
                    matInput
                    data-qa-label="AliasInput"
                    minlength="2"
                    maxlength="5"
                    required
                    formControlName="alias"
                    [matAutocomplete]="aliasAutocomplete"
                    (focus)="generateAliasSuggestions()">
            <span matSuffix class="lbl" (click)="alias.value = ''"></span>
            <mat-autocomplete #aliasAutocomplete="matAutocomplete"
                              (optionSelected)="onAliasSuggestionSelected($event.option.value)">
                <mat-option *ngFor="let suggestion of aliasSuggestions"
                            [value]="suggestion">
                    {{ suggestion }}
                </mat-option>
            </mat-autocomplete>
            <mat-hint>{{ 'form.hint.uppercaseLettersOnly' | translate }}</mat-hint>
            <mat-error *ngIf="form.get('alias').errors?.required">
                {{ 'form.error.required' | translate }}
            </mat-error>
            <mat-error *ngIf="form.get('alias').errors?.pattern">
                {{ 'form.error.uppercaseLetters' | translate }}
            </mat-error>
            <mat-error *ngIf="form.get('alias').errors?.notUnique">
                {{ 'form.error.aliasNotUnique' | translate }}
            </mat-error>
        </mat-form-field>

        <!-- Create Sand box -->
        <div>
            <mat-checkbox class="checkbox"
                        *ngIf="isCreate && !isProduction"
                        (change)="onCreateSandBoxChecked($event.checked)">
                {{ 'brand.businessInfo.createSandbox' | translate }}
            </mat-checkbox>
        </div>

        <mat-form-field class="currency"  *ngIf="!createSandBox">
            <input #currencyFilterInput
                   matInput type="text"
                   matInput
                   *ngIf="currencySelect.panelOpen"
                   [value]="currencyFilterInput.value"
                   [placeholder]="inputFocused ? ('brand.businessInfo.currency' | translate) : null"
                   (input)="filteredCurrencies = filterItems(currencyFilterInput.value, currencies, 'currencyName')"
                   (focus)="inputFocused = true"
                   (blur)="inputFocused = false">
            <!-- Hide mat-select when input is focused -->
            <mat-select matInput
                        #currencySelect
                        data-qa-label="CurrencyInput"
                        panelClass="custom-autocomplete-select currency-select"
                        [ngClass]="{ 'hidden-select': currencySelect.panelOpen }"
                        disableOptionCentering
                        class="currency-select"
                        formControlName="currency"
                        placeholder="{{ 'brand.businessInfo.currency' | translate }}">
                <mat-option *ngFor="let currency of filteredCurrencies"
                            [value]="currency.currencyCode"
                            class="option">
                    {{ currency.currencyName }}
                </mat-option>
            </mat-select>
            <mat-error>
                {{ 'form.error.required' | translate }}
            </mat-error>
        </mat-form-field>

        <mat-form-field class="language"  *ngIf="!createSandBox">
            <input matInput
                   #supportedLanguageFilterInput
                   type="text"
                   *ngIf="languagesSelect.panelOpen"
                   [value]="supportedLanguageFilterInput.value"
                   [placeholder]="inputFocused ? ('brand.businessInfo.language' | translate) : null"
                   (input)="filterLanguagesWithSelected(supportedLanguageFilterInput.value)"
                   (focus)="inputFocused = true"
                   (blur)="inputFocused = false">
            <!-- Hide mat-select when input is focused -->
            <mat-select matInput
                        multiple
                        #languagesSelect
                         data-qa-label="supportedLanguagesInput"
                        panelClass="custom-autocomplete-select language-select"
                        [ngClass]="{ 'hidden-select': languagesSelect.panelOpen }"
                        disableOptionCentering
                        class="language-select"
                        (opened)="onLanguagesPanelOpened()"
                        (closed)="onLanguagesPanelClosed()"
                        (selectionChange)="onSupportedLanguagesChange($event)"
                        formControlName="supportedLanguages"
                        placeholder="{{ 'brand.businessInfo.language' | translate }}">
                <mat-option *ngFor="let language of filteredLanguages"
                            [value]="language.languageCode"
                            class="option">
                        {{ language.languageName }}
                </mat-option>
            </mat-select>
            <mat-error>
                {{ 'form.error.required' | translate }}
            </mat-error>
        </mat-form-field>

        <ng-container [formGroup]="$any(form.get('headquartersAddress').get('coords'))" *ngIf="!createSandBox">
          <mat-form-field class="latitude">
            <mat-label>{{ 'store.storeInfo.lat' | translate }}</mat-label>
            <input formControlName="lat"
                   type="number"
                   step="0.0001"
                   (blur)="form.get('headquartersAddress.coords.lon')?.updateValueAndValidity()"
                   data-qa-label="LatInput"
                   matInput/>

            <mat-error *ngIf="form.get('headquartersAddress.coords.lat')?.errors?.required">
              {{ 'form.error.required' | translate }}
            </mat-error>
            <mat-error *ngIf="form.get('headquartersAddress.coords.lat')?.errors?.min">
              {{ 'form.error.minLatValue' | translate }}
            </mat-error>
            <mat-error *ngIf="form.get('headquartersAddress.coords.lat')?.errors?.max">
              {{ 'form.error.maxLatValue' | translate }}
            </mat-error>
            <mat-error *ngIf="form.get('headquartersAddress.coords.lat')?.errors?.pattern">
              {{ 'form.error.invalidLatNumberFormat' | translate }}
            </mat-error>
          </mat-form-field>
          <mat-form-field class="longitude">
            <mat-label>{{ 'store.storeInfo.long' | translate }}</mat-label>
            <input formControlName="lon"
                   type="number"
                   (blur)="form.get('headquartersAddress.coords.lat')?.updateValueAndValidity()"
                   data-qa-label="LongInput"
                   matInput/>
            <mat-error *ngIf="form.get('headquartersAddress.coords.lon')?.errors?.required">
              {{ 'form.error.required' | translate }}
            </mat-error>
            <mat-error *ngIf="form.get('headquartersAddress.coords.lon')?.errors?.min">
              {{ 'form.error.minLonValue' | translate }}
            </mat-error>
            <mat-error *ngIf="form.get('headquartersAddress.coords.lon')?.errors?.max">
              {{ 'form.error.maxLonValue' | translate }}
            </mat-error>
            <mat-error *ngIf="form.get('headquartersAddress.coords.lon')?.errors?.pattern">
              {{ 'form.error.invalidLongNumberFormat' | translate }}
            </mat-error>
          </mat-form-field>
        </ng-container>

        <div class="distance-unit" *ngIf="!createSandBox">
            <div class="title">
                {{ 'brand.businessInfo.distanceUnit' | translate }}
            </div>
            <txp-type-selector class="distance-selector"
                                [selected]="form.getRawValue().unitOfDistanceMeasure"
                                [disabled]="businessInfoReadOnly"
                                [types]="unitsOfDistanceMeasure"
                                (select)="onSelectUnitOfDistanceMeasure($event)">
            </txp-type-selector>
        </div>

        <mat-form-field class="language default-language" *ngIf="!createSandBox">
            <mat-label>{{ 'brand.businessInfo.defaultLanguage' | translate }}</mat-label>
            <mat-select #defaultLanguage
                            matInput
                            data-qa-label="languageInput"
                            required
                            formControlName="language">
                <mat-option *ngFor="let language of supportedLanguages" [value]="language.languageCode">
                    {{ language.languageName }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="!form.get('language').errors?.lang">
                {{ 'form.error.required' | translate }}
            </mat-error>
            <mat-error *ngIf="form.get('language').errors?.lang">
                {{ 'form.error.defaultLanguageError' | translate }}
            </mat-error>
        </mat-form-field>
    </div>
    <div class="actions" *ngIf="!dataLoading()" [hidden]="businessInfoReadOnly">
        <txp-button
            data-qa-label="CancelButton"
            [disabled]="isSaving || ( form.pristine && !isCreate)"
            [style]="buttonStyle.SECONDARY"
            (click)="onCancel()">
            {{ 'form.button.cancel' | translate }}
        </txp-button>
        <txp-button
            (click)="onSave()"
            data-qa-label="SaveButton"
            [disabled]="isSaving || form.pristine"
            [style]="buttonStyle.PRIMARY"
            [loading]="isSaving">
            {{ 'form.button.save' | translate }}
        </txp-button>
    </div>
</form>

